import { createContext } from "react";

export const ConsentLayoutContext = createContext<{
  label?: string;
  subLabel?: string;
}>({});
